// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__i_OSp","content":"LoadingAlert_content__2fr2l"};